import {
  clamp01,
  easeInOutCubic,
  easeOutBack,
  lerp,
  reactionEnvelope,
} from "./easing.js";

/** Character pose math, independent of PixiJS, DOM, and rendering frame rate. */
export class CatMotion {
  constructor(seed = 0) {
    this.seed = seed;
    this.reaction = null;
    this.revealAt = null;
  }
  reveal(time) {
    this.revealAt = time;
    this.react("happy", time);
  }
  react(mood, time) {
    this.reaction = { mood, time, duration: mood === "sad" ? 1450 : 1150 };
  }
  reacting(time) {
    return this.reaction && time - this.reaction.time < this.reaction.duration;
  }
  sample(time, reduced = false) {
    const elapsed = this.reaction ? Math.max(0, time - this.reaction.time) : 0;
    const weight = this.reacting(time)
      ? reduced
        ? 1
        : reactionEnvelope(elapsed, this.reaction.duration)
      : 0;
    const happy = this.reaction?.mood === "happy" ? weight : 0;
    const sad = this.reaction?.mood === "sad" ? weight : 0;
    const offset = this.seed * 719;
    const period = 3400 + (this.seed % 5) * 173;
    const phase = (time + offset + 1100) % period;
    const blinkPhase = clamp01((phase - period + 190) / 190);
    const blink = reduced
      ? 0
      : phase >= period - 190
        ? Math.sin(blinkPhase * Math.PI) ** 1.2
        : 0;
    const gazePhase = ((time + offset) % 7600) / 1900;
    const gazeStops = [0, -1, 0, 1, 0];
    const segment = Math.floor(gazePhase);
    const gaze = reduced
      ? 0
      : lerp(
          gazeStops[segment],
          gazeStops[segment + 1],
          easeInOutCubic(Math.min(1, (gazePhase % 1) * 1.6)),
        );
    const reveal =
      this.revealAt === null || reduced
        ? 1
        : Math.max(0, easeOutBack((time - this.revealAt) / 390));
    return {
      reveal,
      happy,
      sad,
      eyeOpen: Math.max(0.015, (1 - blink) * (1 - happy * 0.39 - sad * 0.08)),
      gazeX: gaze * (1 - happy * 0.7 - sad * 0.8),
      gazeY: sad * 0.85 - happy * 0.12,
      angle: reduced
        ? 0
        : Math.sin((time + offset) / 2100) * 0.014 +
          gaze * 0.022 +
          Math.sin(elapsed / 100) * happy * 0.055 -
          sad * 0.05,
      xScale: 1 + happy * 0.035 + sad * 0.012,
      yScale:
        1 -
        sad * 0.045 +
        (reduced ? 0 : Math.sin((time + offset) / 1700) * 0.008),
      bob: reduced
        ? 0
        : -Math.abs(Math.sin(elapsed / 155)) * happy * 43 + sad * 24,
      tear: sad * (0.4 + ((elapsed % 650) / 650) * 0.6),
    };
  }
}
